import { ca } from '@cian/analytics';
import {
  IAnalyticsProduct,
  IAnalyticsExtraOfferIds,
  TAnalyticsOfferStatus,
} from '../../../../shared/ServicePickerWidget/types/analytics';

interface IParams {
  analyticsProduct: IAnalyticsProduct;
  analyticsExtraOfferIds: IAnalyticsExtraOfferIds;
  analyticsOfferStatus: TAnalyticsOfferStatus;
}

export const trackPayByCardModalOpen = (params: IParams) => {
  const { analyticsProduct, analyticsExtraOfferIds, analyticsOfferStatus } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'not_enough_money_popup_open',
    label: 'add_offer',
    page: {
      pageType: 'NewAddForm',
      extra: {
        ...analyticsExtraOfferIds,
      },
    },
    products: [analyticsProduct],
  });
};
